import {client} from './client';

class personApi {

    static async all() {
        let response = await client.get('/persons');
        return response.data;
    }

    static async list(params) {
        let response = await client.get('/persons/list', {params});
        return response.data;

    }

    static async getById(id) {
        let response = await client.get('/persons/' + id);
        return response.data;
    }

    static async getByIdCode(idCode, companyId) {
        let response = await client.get('/persons/credentials/' + idCode + '?companyId=' + companyId);
        return response.data;
    }

    static async update(id, model) {
        let response = await client.patch('/persons/' + id, model);
        return response.data;
    }

    static async validate(code) {
        let response = await client.post('/persons/validate', {code: code});
        return response.data;
    }

    static async create(data) {
        let response = await client.post('/persons', data);
        return response.data;
    }

    static async delete(id) {
        let response = await client.delete('/persons/' + id);
        return response.data;
    }

    static async createRemoteAccessLink(data) {
        let response = await client.post('/persons/remote_access_link/create', data);
        return response.data;
    }

    static async updateRoles(model) {
        let response = await client.patch('/persons/' + model.id + '/roles', model);
        return response.data;
    }

    static async updateContact(model) {
        let response = await client.patch('/persons/' + model.id + '/contact', model);
        return response.data;
    }
}

export default personApi;